import { render } from "./Ripple.vue?vue&type=template&id=f42c0f34"
import script from "./Ripple.vue?vue&type=script&lang=js"
export * from "./Ripple.vue?vue&type=script&lang=js"
script.render = render

export default script